// @ts-nocheck
import moment from "moment";
import { utils, writeFile } from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Helpers from "../../../components/Helpers";

export function createSearchExports(ctx: any) {
  const { isShowData, retreatsList, noRetAttend, coupWithAttenType, quickSearchFor } = ctx;

  const handleExport = async () => {
    let headings;
    let exportData = [];
    if (isShowData) {
      retreatsList.forEach((row) => {
        exportData.push({
          retreatTitle: `${row?.parish || ""}${
            row.language
              ? ` (${row.language[0].toUpperCase()}${row.language.slice(1)})`
              : ""
          } ${
            row.location
              ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
              : ""
          },`,
          CoupleId: row.primaryKey,
          Type: row.attendeeType,
          HisLastName: row.hisLastName,
          HisFirstName: row.hisFirstName,
          HerLastName: row.herLastName,
          HerFirstName: row.herFirstName,
          Parish: row.coupleParish,
          ServiceRole: row.role,
          ServiceTitle: row.service,
          Talk: row.talk,
          HisEmail: row.hisEmail,
          HerEmail: row.herEmail,
          HisMobile: row.hisMobile,
          herMobile: row.herMobile,
          address: row.address,
          city: row.city,
          state: row.state,
          zip: row.zip,
          // parish: row.parish,
          Anniversary_date:
            row.anniversary_date !== null
              ? Helpers.convertUtcToTimezone(row.anniversary_date, "MM-DD-YYYY")
              : "",
          Dietary_restrictions_or_physical_limitations: row.allergies,
          Under_age_35: row.under_age_35,
          Emergency_name1: row.emergency_name1,
          Emergency_relationship1: row.emergency_relationship1,
          Emergency_phone1: row.emergency_phone1,
          Emergency_name2: row.emergency_name2,
          Emergency_relationship2: row.emergency_relationship2,
          Emergency_phone2: row.emergency_phone2,
          // How_did_you_hear_about_us: row.hear_us,
          Referral_from_a_friend_or_family_member:
            row.referral_from_a_friend_or_family_member,
          notes: row.notes,
          RetreatDates:
            moment(row.dateFrom).format("MMM DD") +
            "-" +
            moment(row.dateTo).format("MMM DD") +
            "," +
            moment(row.dateFrom).format("YYYY"),
          Status:
            row.accountStatus &&
            row.accountStatus.charAt(0).toUpperCase() +
              row.accountStatus.slice(1).toLowerCase(),
          Created: Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
        });
      });
      headings = [
        [
          "Retreat Title",
          "Couple Id",
          "Type",
          "His Last Name",
          "His First Name",
          "Her Last Name",
          "Her First Name",
          "Parish",
          "Service Role",
          "Service Title",
          "Talk",
          "His Email",
          "Her Email",
          "His Mobile",
          "Her Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Anniversary Date",
          "Dietary Restrictions Or Physical Limitations",
          "Under Age 35",
          "Emergency Name1",
          "Emergency Relationship1",
          "Emergency Phone1",
          "Emergency Name2",
          "Emergency Emergency Relationship2",
          "Emergency Phone2",
          // "How did you hear about us",
          "Referral from a friend/family member",
          "Notes",
          "Retreat Dates",
          "Status",
          "Created",
        ],
      ];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    } else if (!isShowData && !noRetAttend && !coupWithAttenType) {
      retreatsList.forEach((row) => {
        exportData.push({
          RetreatTitle: `${row?.parish || ""}${
            row.language
              ? ` (${row.language[0].toUpperCase()}${row.language.slice(1)})`
              : ""
          } ${
            row.location
              ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
              : ""
          },`,
          language: row.language,
          location: row.location,
          Retreatants: row.countRetreatant,
          Team: row.countTeam,
          retreat_heading: row.heading,
          RetreatDates:
            moment(row.dateFrom).format("MMM DD") +
            "-" +
            moment(row.dateTo).format("MMM DD") +
            "," +
            moment(row.dateFrom).format("YYYY"),

          Created: Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
        });
      });
      headings = [
        [
          "Retreat Title",
          "Language",
          "Location",
          "Retreatants Count",
          "Team Count",
          "Retreat Heading",
          "Retreat Dates",
          "Created",
        ],
      ];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    } else if (noRetAttend) {
      retreatsList.forEach((row) => {
        exportData.push({
          CoupleId: row.primaryKey,
          RetreatAttended: row.retreatsCount,
          Type: row.attendeeType,
          HisLastName: row.hisLastName,
          HisFirstName: row.hisFirstName,
          HerLastName: row.herLastName,
          HerFirstName: row.herFirstName,
          Parish: row.coupleParish,
          ServiceRole: row.role,
          ServiceTitle: row.service,
          Talk: row.talk,
          HisEmail: row.hisEmail,
          HerEmail: row.herEmail,
          HisMobile: row.hisMobile,
          HerMobile: row.herMobile,
          address: row.address,
          city: row.city,
          state: row.state,
          zip: row.zip,
          Anniversary_date:
            row.anniversary_date !== null
              ? Helpers.convertUtcToTimezone(row.anniversary_date, "MM-DD-YYYY")
              : "",
          Dietary_restrictions_or_physical_limitations: row.allergies,
          Under_age_35: row.under_age_35,
          Emergency_name1: row.emergency_name1,
          Emergency_relationship1: row.emergency_relationship1,
          Emergency_phone1: row.emergency_phone1,
          Emergency_name2: row.emergency_name2,
          Emergency_relationship2: row.emergency_relationship2,
          Emergency_phone2: row.emergency_phone2,
          // How_did_you_hear_about_us: row.hear_us,
          Referral_from_a_friend_or_family_member:
            row.referral_from_a_friend_or_family_member,
          notes: row.notes,
          RetreatDates:
            moment(row.dateFrom).format("MMM DD") +
            "-" +
            moment(row.dateTo).format("MMM DD") +
            "," +
            moment(row.dateFrom).format("YYYY"),
          Status:
            row.accountStatus &&
            row.accountStatus.charAt(0).toUpperCase() +
              row.accountStatus.slice(1).toLowerCase(),
        });
      });
      headings = [
        [
          "Couple Id",
          "Retreat Attended",
          "Type",
          "His Last Name",
          "His First Name",
          "Her Last Name",
          "Her First Name",
          "Parish",
          "Service Role",
          "Service Title",
          "Talk",
          "His Email",
          "Her Email",
          "His Mobile",
          "Her Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Anniversary Date",
          "Dietary Restrictions Or Physical Limitations",
          "Under Age 35",
          "Emergency Name1",
          "Emergency Relationship1",
          "Emergency Phone1",
          "Emergency Name2",
          "Emergency Relationship2",
          "Emergency Phone2",
          // "How did you hear about us",
          "Referral from a friend/family member",
          "Notes",
          "Retreat Dates",
          "Status",
        ],
      ];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    } else if (coupWithAttenType) {
      retreatsList.forEach((row) => {
        exportData.push({
          RetreatTitle: row.title.charAt(0).toUpperCase() + row.title.slice(1),
          CoupleId: row.primaryKey,
          Type: row.attendeeType,
          HisLastName: row.hisLastName,
          HisFirstName: row.hisFirstName,
          HerLastName: row.herLastName,
          HerFirstName: row.herFirstName,
          Parish: row.coupleParish,
          ServiceRole: row.role,
          ServiceTitle: row.service,
          Talk: row.talk,
          HisEmail: row.hisEmail,
          HerEmail: row.herEmail,
          HisMobile: row.hisMobile,
          HerMobile: row.herMobile,
          address: row.address,
          city: row.city,
          state: row.state,
          zip: row.zip,
          Anniversary_date:
            row.anniversary_date !== null
              ? Helpers.convertUtcToTimezone(row.anniversary_date, "MM-DD-YYYY")
              : "",
          Dietary_restrictions_or_physical_limitations: row.allergies,
          Under_age_35: row.under_age_35,
          Emergency_name1: row.emergency_name1,
          Emergency_relationship1: row.emergency_relationship1,
          Emergency_phone1: row.emergency_phone1,
          Emergency_name2: row.emergency_name2,
          Emergency_relationship2: row.emergency_relationship2,
          Emergency_phone2: row.emergency_phone2,
          // How_did_you_hear_about_us: row.hear_us,
          Referral_from_a_friend_or_family_member:
            row.referral_from_a_friend_or_family_member,
          notes: row.notes,
          RetreatDates:
            moment(row.dateFrom).format("MMM DD") +
            "-" +
            moment(row.dateTo).format("MMM DD") +
            "," +
            moment(row.dateFrom).format("YYYY"),
          Status:
            row.accountStatus &&
            row.accountStatus.charAt(0).toUpperCase() +
              row.accountStatus.slice(1).toLowerCase(),
        });
      });
      headings = [
        [
          "Retreat Title",
          "Couple Id",
          "Type",
          "His Last Name",
          "His First Name",
          "Her Last Name",
          "Her First Name",
          "Parish",
          "Service Role",
          "Service Title",
          "Talk",
          "His Email",
          "Her Email",
          "His Mobile",
          "Her Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Anniversary Date",
          "Dietary Restrictions Or Physical Limitations",
          "Under Age 35",
          "Emergency Name1",
          "Emergency Relationship1",
          "Emergency Phone1",
          "Emergency Name2",
          "Emergency Emergency Relationship2",
          "Emergency Phone2",
          // "How did you hear about us",
          "Referral from a friend/family member",
          "Notes",
          "Retreat Dates",
          "Status",
        ],
      ];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    }
    
  };

  const exportFlockNotes = async () => {
    let headings;
    let exportData = [];
    if (isShowData) {
      retreatsList.forEach((row) => {
        // Push his data
        exportData.push({
          firstName: row.hisFirstName,
          lastName: row.hisLastName,
          email: row.hisEmail,
          mobile: row.hisMobile,
          // RetreatTitle: row.title,
        });
        // Push her data
        exportData.push({
          firstName: row.herFirstName,
          lastName: row.herLastName,
          email: row.herEmail,
          mobile: row.herMobile,
          // RetreatTitle: row.title,
        });
      });
      const headings = [["First Name", "Last Name", "Email", "Mobile"]];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    } else if (!isShowData && !noRetAttend && !coupWithAttenType) {
      retreatsList.forEach((row) => {
        exportData.push({
          RetreatTitle: row.title,
          language: row.language,
          location: row.location,
          Retreatants: row.countRetreatant,
          Team: row.countTeam,
          retreat_heading: row.heading,
          RetreatDates:
            moment(row.dateFrom).format("MMM DD") +
            "-" +
            moment(row.dateTo).format("MMM DD") +
            "," +
            moment(row.dateFrom).format("YYYY"),

          Created: Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
        });
      });
      headings = [
        [
          "Retreat Title",
          "Language",
          "Location",
          "Retreatants Count",
          "Team Count",
          "Retreat Heading",
          "Retreat Dates",
          "Created",
        ],
      ];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    } else if (noRetAttend) {
      retreatsList.forEach((row) => {
        // Push his data
        exportData.push({
          firstName: row.hisFirstName,
          lastName: row.hisLastName,
          email: row.hisEmail,
          mobile: row.hisMobile,
          RetreatAttended: row.retreatsCount,
        });
        // Push her data
        exportData.push({
          firstName: row.herFirstName,
          lastName: row.herLastName,
          email: row.herEmail,
          mobile: row.herMobile,
          RetreatAttended: row.retreatsCount,
        });
      });
      const headings = [["First Name", "Last Name", "Email", "Mobile"]];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    } else if (coupWithAttenType) {
      retreatsList.forEach((row) => {
        // Push his data
        exportData.push({
          firstName: row.hisFirstName,
          lastName: row.hisLastName,
          email: row.hisEmail,
          mobile: row.hisMobile,
          // RetreatTitle: row.title.charAt(0).toUpperCase() + row.title.slice(1),
        });
        // Push her data
        exportData.push({
          firstName: row.herFirstName,
          lastName: row.herLastName,
          email: row.herEmail,
          mobile: row.herMobile,
          // RetreatTitle: row.title.charAt(0).toUpperCase() + row.title.slice(1),
        });
      });
      const headings = [["First Name", "Last Name", "Email", "Mobile"]];
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, { origin: "A2", skipHeader: true });
      utils.book_append_sheet(wb, ws, "Data");
      writeFile(
        wb,
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` +
          ".xlsx"
      );
    }
    
  };

  const exportPdf = async () => {
    const unit = "pt";
    const size = "A1"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    const title = "Searched Data";
    let headings;
    if (isShowData) {
      const exportData = retreatsList.map((row) => [
        row.title,
        row.primaryKey,
        row.attendeeType,
        row.hisLastName,
        row.hisFirstName,
        row.herLastName,
        row.herFirstName,
        // row.coupleParish,
        row.role,
        row.service,
        row.talk,
        row.hisEmail,
        row.herEmail,
        row.hisMobile,
        row.herMobile,
        row.address,
        row.city,
        row.state,
        row.zip,
        row.coupleParish,
        row.anniversary_date !== null
          ? Helpers.convertUtcToTimezone(row.anniversary_date, "MM-DD-YYYY")
          : "",
        row.allergies,
        row.under_age_35,
        row.emergency_name1,
        row.emergency_relationship1,
        row.emergency_phone1,
        row.emergency_name2,
        row.emergency_relationship2,
        row.emergency_phone2,
        // row.hear_us,
        row.referral_from_a_friend_or_family_member,
        row.notes,
        moment(row.dateFrom).format("MMM DD") +
          "-" +
          moment(row.dateTo).format("MMM DD") +
          "," +
          moment(row.dateFrom).format("YYYY"),
        row.accountStatus &&
          row.accountStatus.charAt(0).toUpperCase() +
            row.accountStatus.slice(1).toLowerCase(),

        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      ]);
      headings = [
        [
          "Retreat Title",
          "Couple Id",
          "Type",
          "His Last Name",
          "His First Name",
          "Her Last Name",
          "Her First Name",
          "Service Role",
          "Service Title",
          "Talk",
          "His Email",
          "Her Email",
          "His Mobile",
          "Her Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Parish",
          "Anniversary Date",
          "Dietary Restrictions Or Physical Limitations",
          "Under Age 35",
          "Emergency Name1",
          "Emergency Relationship1",
          "Emergency Phone1",
          "Emergency Name2",
          "Emergency Emergency Relationship2",
          "Emergency Phone2",
          // "How did you hear about us",
          "Referral from a friend/family member",
          "Notes",
          "Retreat Dates",
          "Status",
          "Created",
        ],
      ];
      let content = {
        head: headings,
        body: exportData,
        startY: 70,
        theme: "grid",
        tableLineColor: [189, 195, 199],
        tableLineWidth: 0.75,
      };
      doc.text(title, marginLeft, 40);
      doc.autoTable(content);
      doc.save(
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` + ".pdf"
      );
    } else if (!isShowData && !noRetAttend && !coupWithAttenType) {
      const exportData = retreatsList.map((row) => [
        row.title,
        row.language,
        row.location,
        row.countRetreatant,
        row.countTeam,
        row.heading,
        moment(row.dateFrom).format("MMM DD") +
          "-" +
          moment(row.dateTo).format("MMM DD") +
          "," +
          moment(row.dateFrom).format("YYYY"),
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      ]);
      headings = [
        [
          "Retreat Title",
          "Language",
          "Location",
          "Retreatants Count",
          "Team Count",
          "Retreat Heading",
          "Retreat Dates",
          "Created",
        ],
      ];
      let content = {
        head: headings,
        body: exportData,
        startY: 70,
        theme: "grid",
        tableLineColor: [189, 195, 199],
        tableLineWidth: 0.75,
      };
      doc.text(title, marginLeft, 40);
      doc.autoTable(content);
      doc.save(
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` + ".pdf"
      );
    } else if (noRetAttend) {
      const exportData = retreatsList.map((row) => [
        row.primaryKey,
        row.retreatsCount,
        row.attendeeType,
        row.hisLastName,
        row.hisFirstName,
        row.herLastName,
        row.herFirstName,
        // row.coupleParish,
        row.role,
        row.service,
        row.talk,
        row.hisEmail,
        row.herEmail,
        row.hisMobile,
        row.herMobile,
        row.address,
        row.city,
        row.state,
        row.zip,
        row.coupleParish,
        row.anniversary_date !== null
          ? Helpers.convertUtcToTimezone(row.anniversary_date, "MM-DD-YYYY")
          : "",
        row.allergies,
        row.under_age_35,
        row.emergency_name1,
        row.emergency_relationship1,
        row.emergency_phone1,
        row.emergency_name2,
        row.emergency_relationship2,
        row.emergency_phone2,
        // row.hear_us,
        row.notes,
        moment(row.dateFrom).format("MMM DD") +
          "-" +
          moment(row.dateTo).format("MMM DD") +
          "," +
          moment(row.dateFrom).format("YYYY"),
        row.accountStatus &&
          row.accountStatus.charAt(0).toUpperCase() +
            row.accountStatus.slice(1).toLowerCase(),
      ]);
      headings = [
        [
          "Couple Id",
          "Retreat Attended",
          "Type",
          "His Last Name",
          "His First Name",
          "Her Last Name",
          "Her First Name",
          "Service Role",
          "Service Title",
          "Talk",
          "His Email",
          "Her Email",
          "His Mobile",
          "Her Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Parish",
          "Anniversary Date",
          "Dietary Restrictions Or Physical Limitations",
          "Under Age 35",
          "Emergency Name1",
          "Emergency Relationship1",
          "Emergency Phone1",
          "Emergency Name2",
          "Emergency Emergency Relationship2",
          "Emergency Phone2",
          // "How did you hear about us",
          "Referral from a friend/family member",
          "Notes",
          "Retreat Dates",
          "Status",
        ],
      ];
      let content = {
        head: headings,
        body: exportData,
        startY: 70,
        theme: "grid",
        tableLineColor: [189, 195, 199],
        tableLineWidth: 0.75,
      };
      doc.text(title, marginLeft, 40);
      doc.autoTable(content);
      doc.save(
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` + ".pdf"
      );
    } else if (coupWithAttenType) {
      const exportData = retreatsList.map((row) => [
        row.title.charAt(0).toUpperCase() + row.title.slice(1),
        row.primaryKey,
        row.attendeeType,
        row.hisLastName,
        row.hisFirstName,
        row.herLastName,
        row.herFirstName,
        // row.coupleParish,
        row.role,
        row.service,
        row.talk,
        row.hisEmail,
        row.herEmail,
        row.hisMobile,
        row.herMobile,
        row.address,
        row.city,
        row.state,
        row.zip,
        row.coupleParish,
        row.anniversary_date !== null
          ? Helpers.convertUtcToTimezone(row.anniversary_date, "MM-DD-YYYY")
          : "",
        row.allergies,
        row.under_age_35,
        row.emergency_name1,
        row.emergency_relationship1,
        row.emergency_phone1,
        row.emergency_name2,
        row.emergency_relationship2,
        row.emergency_phone2,
        // row.hear_us,
        row.notes,
        moment(row.dateFrom).format("MMM DD") +
          "-" +
          moment(row.dateTo).format("MMM DD") +
          "," +
          moment(row.dateFrom).format("YYYY"),
        row.accountStatus &&
          row.accountStatus.charAt(0).toUpperCase() +
            row.accountStatus.slice(1).toLowerCase(),
      ]);
      headings = [
        [
          "Retreat Title",
          "Couple Id",
          "Type",
          "His Last Name",
          "His First Name",
          "Her Last Name",
          "Her First Name",
          "Service Role",
          "Service Title",
          "Talk",
          "His Email",
          "Her Email",
          "His Mobile",
          "Her Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Parish",
          "Anniversary Date",
          "Dietary Restrictions Or Physical Limitations",
          "Under Age 35",
          "Emergency Name1",
          "Emergency Relationship1",
          "Emergency Phone1",
          "Emergency Name2",
          "Emergency Emergency Relationship2",
          "Emergency Phone2",
          // "How did you hear about us",
          "Referral from a friend/family member",
          "Notes",
          "Retreat Dates",
          "Status",
        ],
      ];
      let content = {
        head: headings,
        body: exportData,
        startY: 70,
        theme: "grid",
        tableLineColor: [189, 195, 199],
        tableLineWidth: 0.75,
      };
      doc.text(title, marginLeft, 40);
      doc.autoTable(content);
      doc.save(
        `${quickSearchFor ? `Quick Search Results` : `Search Results`}` + ".pdf"
      );
    }
  };

  return { handleExport, exportFlockNotes, exportPdf };
}